import { render, staticRenderFns } from "./SampleStatus.vue?vue&type=template&id=2571adc1"
import script from "./SampleStatus.vue?vue&type=script&lang=js"
export * from "./SampleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports